import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useBranchFilter } from '../context/branchContext';

const ALL_BRANCHES = 'all';

/** Only renders anything meaningful for Super Admin — see BranchProvider. */
export const BranchSelector = () => {
  const { branches, selectedBranchId, setSelectedBranchId } = useBranchFilter();

  if (branches.length === 0) return null;

  const handleChange = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setSelectedBranchId(value === ALL_BRANCHES ? undefined : Number(value));
  };

  return (
    <Select
      size="small"
      value={selectedBranchId ? String(selectedBranchId) : ALL_BRANCHES}
      onChange={handleChange}
      sx={{ minWidth: 160, '& .MuiSelect-select': { py: 0.75 } }}
    >
      <MenuItem value={ALL_BRANCHES}>All branches</MenuItem>
      {branches.map((branch) => (
        <MenuItem key={branch.id} value={String(branch.id)}>
          {branch.name}
        </MenuItem>
      ))}
    </Select>
  );
};
